var React = require('react');

function HundredZeroInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"188","cy":"342","r":"188","fill":"#FF5A7D","key":0}),React.createElement("circle",{"cx":"188","cy":"342","r":"188","fill":"#B1F8FC","mask":"url(#zero_mask)","key":1}),React.createElement("circle",{"cx":"188","cy":"342","r":"106","fill":"#fff","key":2}),React.createElement("defs",{"key":3},React.createElement("mask",{"id":"zero_mask"},React.createElement("rect",{"x":"0","y":"376","width":"376","height":"154","fill":"#fff"})))]);
}

HundredZeroInline.defaultProps = {"width":"376","height":"530","viewBox":"0 0 376 530","fill":"none"};

module.exports = HundredZeroInline;

HundredZeroInline.default = HundredZeroInline;
